import { Auth } from '../components/auth/cognito_auth';
import axios from 'axios'

var AWS = require("aws-sdk/global");

const properties = {
    invokeUrl: process.env.VUE_APP_AWS_API_GATEWAY_CUSTOMER_INVOKATION_URL,
    pathTemplate: '/customer/billinginfo'
}

export default {
    name: 'CustomerBillingInfoService',

    getCustomerBillingInfoPromise: function () {
        return AWS.config.credentials.getPromise().then(function () {
            var id_token = Auth.getIdToken();
            return axios
                .get(properties.invokeUrl + properties.pathTemplate, {
                    headers: {
                        Authorization: `Bearer ${id_token}`
                    }
                })
        }, function (err) {
            prompt(err);
        });
    },

    createCustomerBillingInfoPromise: function (customerBillingInfo) {
        return AWS.config.credentials.getPromise().then(function () {
            var id_token = Auth.getIdToken();
            return axios.post(properties.invokeUrl + properties.pathTemplate, customerBillingInfo, {
                headers: {
                    Authorization: `Bearer ${id_token}`
                }
            })
        }, function (err) {
            prompt(err);
        });
    }
}